<template>
  <el-dialog title="充值" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <el-form :model="dataForm" class="dataFormClass" :rules="dataRule" ref="dataForm" label-width="auto">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="dataForm.username" disabled autocomplete="off"  style="width:96%;" />
        </el-form-item>
        <el-form-item label="余额" prop="balance">
          <el-input v-model="dataForm.balance" disabled autocomplete="off"  style="width:96%;padding-right:5px" /> 元
        </el-form-item>
        <el-form-item label="充值金额" prop="amount">
          <el-input v-model="dataForm.amount" autocomplete="off"  style="width:96%;padding-right:5px" /> 元
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" autocomplete="off" style="width:96%;"/>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { eventBus } from './eventBus';  // 导入 eventBus

export default {
  data () {
    return {
      visible: false,
      submitLoading: false, 
      dataForm: {
        username: '',
        amount: '',
        remark: '',
      },
      dataRule: {
        amount: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    init (row) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();

        // 设置用户名和初始备注
        this.dataForm = {
          username: row.username || '',
          balance: row. balance || '',
          amount: '', // 初始为空
          remark: row.remark || '',
        };
      });
    },
    reset () {
      this.$refs.dataForm.resetFields();
    },
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const amount = parseFloat(this.dataForm.amount);
          if (isNaN(amount)) {
            this.$message({
              message: '请输入有效的充值金额',
              type: 'error',
              duration: 1500,
            });
            this.submitLoading = false;
            return;
          }

          const tmp = {
            username: this.dataForm.username,
            amount: amount.toFixed(2),
            remark: this.dataForm.remark,
          };

          this.$axios.post('/api/user-recharge', tmp)
            .then(response => {
              this.visible = false;
              this.submitLoading = false;
              this.$message({
                message: '充值成功',
                type: 'success',
                duration: 1500,
              });
              // 触发事件刷新列表
              eventBus.$emit('refresh-list');
            }).catch(error => {
              this.$message({
                message: '充值失败',
                type: 'error',
                duration: 1500,
              });
              this.submitLoading = false;
            });
        }
      });
    },
  },
}
</script>
<style scoped>
.dataFormClass {
  padding-right: 20px;
}
.dataFormClass el-input{
 width: 90%;
}
</style>